import { render, staticRenderFns } from "./s-box.vue?vue&type=template&id=d44ccf58&scoped=true"
import script from "./s-box.vue?vue&type=script&lang=js"
export * from "./s-box.vue?vue&type=script&lang=js"
import style0 from "./s-box.vue?vue&type=style&index=0&id=d44ccf58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44ccf58",
  null
  
)

export default component.exports